module.exports = __webpack_public_path__ + "26a195de8eed70c1be4afe687905189f.svg";